const Cache = {
  productOffers: [],
  bankOffers: [],
  banksMeta: {},
  websiteOffers: [],
  weeklyAds: [],
  vendors: [],
  specialOffers: [],
  promoCodes: [],

  setData(data) {
    const {
      productOffers = [],
      bankOffers = [],
      banksMeta = {},
      websiteOffers = [],
      weeklyAds = [],
      vendors = [],
      specialOffers = [],
      promoCodes = [],
    } = data || {};

    this.productOffers = productOffers;
    this.bankOffers = bankOffers;
    this.banksMeta = banksMeta;
    this.websiteOffers = websiteOffers;
    this.weeklyAds = weeklyAds;
    this.vendors = vendors;
    this.specialOffers = specialOffers;
    this.promoCodes = promoCodes;
  },

  getData() {
    return {
      productOffers: this.productOffers,
      bankOffers: this.bankOffers,
      banksMeta: this.banksMeta,
      websiteOffers: this.websiteOffers,
      weeklyAds: this.weeklyAds,
      vendors: this.vendors,
      specialOffers: this.specialOffers,
      promoCodes: this.promoCodes,
    };
  },

  clear() {
    this.productOffers = [];
    this.bankOffers = [];
    this.banksMeta = {};
    this.websiteOffers = [];
    this.weeklyAds = [];
    this.vendors = [];
    this.specialOffers = [];
    this.promoCodes = [];
  },
};

export default Cache;
